

import { alpha } from "@mui/material/styles";

const cardShadow = "0 14px 40px rgba(24, 94, 41, 0.18)";

const PricingPageStyles = {
  pageBg: (theme) => ({
    minHeight: "100vh",
    background:
      theme.palette.mode === "dark"
        ? `radial-gradient(1200px 800px at 10% -10%, ${alpha(theme.palette.primary.main, 0.15)} 0%, transparent 60%),
           radial-gradient(1200px 800px at 110% 10%, ${alpha(theme.palette.success.main, 0.12)} 0%, transparent 60%),
           linear-gradient(180deg, ${alpha(theme.palette.background.default, 0.9)} 0%, ${theme.palette.background.default} 100%)`
        : `radial-gradient(1200px 800px at 10% -10%, ${alpha("#81c241", 0.18)} 0%, transparent 60%),
           radial-gradient(1200px 800px at 110% 10%, ${alpha("#81c241", 0.14)} 0%, transparent 60%),
           linear-gradient(180deg, #f7fbf8 0%, #f1f7f3 100%)`,
  }),

  pageTitle: {
    fontWeight: 800,
    letterSpacing: "-0.02em",
    textAlign: "center",
  },
  pageSubtitle: {
    mt: 1,
    color: "text.secondary",
    maxWidth: 920,
    mx: "auto",
    textAlign: "center",
  },

  tabsWrap: { display: "flex", justifyContent: "center", mt: 4 },
  tabs: {
    bgcolor: "background.paper",
    borderRadius: 999,
    px: 1,
    boxShadow: "0 10px 30px rgba(0,0,0,.06)",
  },
  tab: {
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 600,
    px: 2.25,
    "&.Mui-selected": { bgcolor: "action.hover" },
  },

  planCard: {
    p: { xs: 2.5, md: 3.5 },
    borderRadius: 3,
    bgcolor: "background.paper",
    boxShadow: cardShadow,
    transition: "transform .25s ease, box-shadow .25s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 18px 56px rgba(24, 94, 41, 0.26)",
    },
  },
  badge: { fontWeight: 700, borderRadius: 999 },
  planTitle: { fontWeight: 700, letterSpacing: "-0.01em" },
  planPrice: { fontWeight: 800, color: "success.darker" },
  planSubtitle: { color: "text.secondary", mt: 0.5 },
  divider: { my: 2.25 },

  featuresList: { px: 0, my: 1 },
  featureItem: { py: 0.5 },
  featureIcon: { minWidth: 36, color: "success.main" },

  cardActions: { mt: 0.5 },
  ctaButton: {
    py: 1.25,
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 700,
    boxShadow: "0 12px 26px rgba(46,125,50,.35)",
  },

  totalBox: {
    mt: 2,
    mb: 1,
    p: 2,
    borderRadius: 2,
    bgcolor: (theme) => alpha(theme.palette.success.main, 0.06),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
};

export default PricingPageStyles;






















// const PricingPageStyles = {
//   pageContainer: {
//     padding: { xs: '2rem 1rem', md: '4rem 2rem' },
//     background: 'linear-gradient(135deg, #f5f7f5, #e8f0e8)', // Subtle green-tinted gradient
//     minHeight: '100vh',
//     textAlign: 'center',
//   },
//   pageTitle: {
//     fontWeight: '700',
//     color: '#388E3C', // Deep green
//     marginBottom: '1rem',
//     fontSize: { xs: '2rem', md: '3rem' },
//   },
//   pageSubtitle: {
//     color: '#555',
//     marginBottom: '3rem',
//     fontSize: { xs: '1rem', md: '1.25rem' },
//     maxWidth: '600px',
//     margin: '0 auto',
//   },
//   toggleButtonGroup: {
//     display: 'flex',
//     justifyContent: 'center',
//     marginBottom: '3rem',
//     backgroundColor: '#fff',
//     borderRadius: '30px',
//     boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden',
//   },
//   toggleButton: {
//     padding: '10px 30px',
//     fontWeight: '600',
//     fontSize: '1rem',
//     color: '#388E3C', // Deep green
//     border: 'none',
//     '&.Mui-selected': {
//       background: 'linear-gradient(45deg, #7AC142, #9CCC65)', // Lime green gradient
//       color: '#fff',
//     },
//     '&:hover': {
//       backgroundColor: '#e8f0e8', // Light green hover
//     },
//   },
//   planCard: {
//     padding: { xs: '2rem', md: '3rem' },
//     borderRadius: '20px',
//     backgroundColor: '#fff',
//     boxShadow: '0px 10px 30px rgba(56, 142, 60, 0.15)', // Green-tinted shadow
//     transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
//     '&:hover': {
//       transform: 'translateY(-10px)',
//       boxShadow: '0px 15px 40px rgba(56, 142, 60, 0.25)',
//     },
//   },
//   planName: {
//     fontWeight: '600',
//     color: '#388E3C', // Deep green
//     marginBottom: '1.5rem',
//   },
//   planPrice: {
//     fontWeight: '700',
//     color: '#7AC142', // Lime green
//     marginBottom: '0.5rem',
//     fontSize: { xs: '2rem', md: '2.5rem' },
//   },
//   planSubtext: {
//     color: '#666',
//     marginBottom: '1.5rem',
//     fontStyle: 'italic',
//     fontSize: '1rem',
//   },
//   planDescription: {
//     color: '#444',
//     marginBottom: '2rem',
//     maxWidth: '400px',
//     margin: '0 auto',
//   },
//   featuresList: {
//     textAlign: 'left',
//     padding: '0 1rem',
//     marginBottom: '2rem',
//     listStyleType: 'none',
//   },
//   featureItem: {
//     marginBottom: '1rem',
//     color: '#444',
//     display: 'flex',
//     alignItems: 'center',
//     '&::before': {
//       content: '"✔"',
//       color: '#7AC142', // Lime green checkmark
//       marginRight: '10px',
//     },
//   },
//   ctaButton: {
//     background: 'linear-gradient(45deg, #388E3C, #7AC142)', // Green to lime green
//     color: '#fff',
//     padding: '12px 36px',
//     fontSize: '1.1rem',
//     fontWeight: '600',
//     borderRadius: '30px',
//     boxShadow: '0px 6px 15px rgba(56, 142, 60, 0.3)',
//     textTransform: 'none',
//     '&:hover': {
//       background: 'linear-gradient(45deg, #2E7D32, #66BB6A)', // Darker green gradient
//       boxShadow: '0px 8px 20px rgba(56, 142, 60, 0.4)',
//     },
//     '&:disabled': {
//       background: '#ccc',
//       boxShadow: 'none',
//     },
//     transition: 'all 0.3s ease-in-out',
//   },
//   errorText: {
//     marginTop: '1rem',
//   },
// };

// export default PricingPageStyles;